export default __webpack_public_path__ + "static/media/webbing5.1f72645c.png";